import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibrarySchoolInviteNoSlotsConfirm = props => (
	<Confirm
		btTwo={localize('action_button_gotit_cancel')}
		alertMessage={localize('bulk_notAvailable_slots')}
		actionTwo={props.actions.closeSchoolInviteNoSlotsConfirm}
		closeAction={props.actions.closeSchoolInviteNoSlotsConfirm}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeSchoolInviteNoSlotsConfirm: myLibraryActions.closeSchoolInviteNoSlotsConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibrarySchoolInviteNoSlotsConfirm)

export { MyLibrarySchoolInviteNoSlotsConfirm }
